export default __webpack_public_path__ + "static/media/filled_check_appointment.675a9fb4.svg";